import React from 'react';


import Number from '../Number';


function ShortNumber(props) {

    return (
        <Number
            notation={'compact'}
            unitDisplay={'short'}
            {...props}
        />
    );
}


ShortNumber.propTypes = {
    ...Number.propTypes
};

ShortNumber.defaultProps = {
    ...ShortNumber.defaultProps
};


export default ShortNumber;
